import React from 'react';

import colors from '../../customizations/js/color-variables';

export const IconsDefs = () => (
  <svg width="0" height="0">
    <defs>
      {/* Gradient */}
      <linearGradient id="linear-gradient-primary" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>

      <linearGradient id="icons-header-linear-gradient-1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#00B147" />
        <stop offset="100%" stopColor="#008E39" />
      </linearGradient>
      {/* end Gradient */}

      {/* IconUser */}
      <clipPath id="icon-user-0">
        <path
          className="icon-filled-path icon-stroked-path"
          fill="#fff"
          d="M0 0h320v1208H0z"
          transform="translate(-113 -11)"
        />
      </clipPath>
      {/* end IconUser */}

      {/* IconAlert */}
      <clipPath id="icon-alert-clip0_4406_25242">
        <rect width="15.7143" height="15.7143" fill="white" transform="translate(14.1424 14.1431)" />
      </clipPath>

      <clipPath id="icon-alert-outlined">
        <rect width="27.4286" height="27.4286" fill="white" transform="translate(12.2852 12.2857)" />
      </clipPath>
      {/* end IconAlert */}

      {/* IconGameTags */}
      <clipPath id="icon-game-tags-clip">
        <rect width="26" height="26" fill="white" />
      </clipPath>
      {/* IconGameTags end */}

      {/* Characters shape gradient */}
      <linearGradient id="linear-gradient-characters-shape" x1="85.309%" x2="57.183%" y1="83.286%" y2="19.874%">
        <stop offset="0%" stopColor="#35353C" />
        <stop offset="100%" stopColor="#545457" />
      </linearGradient>
      <linearGradient id="linear-gradient-characters-shape-active" x1="27.737%" x2="50%" y1="6.549%" y2="79.5%">
        <stop offset="0%" stopColor="#0E97FF" />
        <stop offset="100%" stopColor="#006BFF" />
      </linearGradient>
      {/* end Characters shape gradient */}

      {/* Loyalty Card Active shape gradient */}
      <linearGradient id="linear-gradient-loyalty-card-shape-active" x1="27.737%" x2="50%" y1="6.549%" y2="79.5%">
        <stop offset="0%" stopColor="#0E97FF" />
        <stop offset="100%" stopColor="#006BFF" />
      </linearGradient>
      {/* end Loyalty Card gradient */}

      {/* IconHomeLink */}
      <path id="icon-home-link" d="M0 0h24v26.4H0z" />
      <linearGradient id="icon-home-link-active" x1="8.678%" x2="91.322%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF0061" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      {/* end IconHomeLink */}

      {/* IconErrorCircle */}
      <linearGradient id="icon-error-circle" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF0061" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      {/* end IconErrorCircle */}

      {/* IconGalaxysBig */}
      <clipPath id="galaxysbig1">
        <rect width="138" height="20" fill="white" />
      </clipPath>
      {/* end IconGalaxysBig */}

      {/* IconProviderHigh5Big */}
      <clipPath id="iconProviderHigh5big-1">
        <rect width="139" height="30" fill="white" />
      </clipPath>
      {/* end IconProviderHigh5Big */}

      {/* IconLaurelWreath */}
      <linearGradient id="laurel-wreath-a" x1="19.153%" x2="77.633%" y1="16.798%" y2="90.79%">
        <stop offset="0%" stopColor="#EAFAFF" />
        <stop offset="100%" stopColor="#9EAFB9" />
      </linearGradient>
      {/* end  IconLaurelWreath */}

      {/* IconProviderPoker start */}
      <clipPath id="icon-provider-poker-1">
        <rect width="47.4582" height="45" fill="white" />
      </clipPath>
      {/* IconProviderPoker end */}

      {/* IconProviderEvolution */}
      <linearGradient id="icon-provider-evolution-a" x1="49.331%" x2="40.951%" y1="56.675%" y2="109.287%">
        <stop offset="0%" stopColor="#DADCDF" />
        <stop offset="100%" stopColor="#A8A8A8" />
      </linearGradient>
      <linearGradient id="icon-provider-evolution-b" x1="56.127%" x2="47.746%" y1="9.109%" y2="61.747%">
        <stop offset="0%" stopColor="#DADCDF" />
        <stop offset="100%" stopColor="#A8A8A8" />
      </linearGradient>
      <radialGradient
        id="icon-provider-evolution-c"
        cx="30.185%"
        cy="52.265%"
        r="92.759%"
        fx="30.185%"
        fy="52.265%"
        gradientTransform="matrix(1 0 0 .84748 0 .08)"
      >
        <stop offset="0%" stopColor="#C2C2C2" />
        <stop offset="22%" stopColor="#BDBDBD" />
        <stop offset="46%" stopColor="#B0B0B0" />
        <stop offset="72%" stopColor="#999" />
        <stop offset="99%" stopColor="#7A7A7A" />
        <stop offset="100%" stopColor="#787878" />
      </radialGradient>
      {/* end IconProviderEvolution */}

      {/* IconProviderGamomat */}
      <path id="icon-provider-gamotat-a" d="M0 0H24V24H0z" />
      <mask id="icon-provider-gamotat-b" fill="#fff">
        <use xlinkHref="#icon-provider-gamotat-a" />
      </mask>
      {/* end IconProviderGamomat */}

      {/* IconProviderBooongo */}
      <linearGradient
        id="icon-provider-boongo-1"
        x1="-0.435292"
        y1="17.5083"
        x2="31.8612"
        y2="17.5083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#68F28B" />
        <stop offset="1" stopColor="#00FFDE" />
      </linearGradient>
      {/* end IconProviderBooongo */}

      {/* IconProviderMicroGaming */}
      <linearGradient
        id="icon-microgaming-0"
        x1="5.81398"
        y1="31.7619"
        x2="32.0695"
        y2="5.53494"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#21E31A" />
        <stop offset="1" stopColor="#31B7E7" />
      </linearGradient>
      {/* end IconProviderMicroGaming */}

      {/* IconProviderPlankGaming */}
      <linearGradient id="icon-plank-gaming-b" x1="50.013%" x2="50.013%" y1="100%" y2="0%">
        <stop offset="24%" stopColor="#FFCB05" />
        <stop offset="38%" stopColor="#F8C406" />
        <stop offset="100%" stopColor="#DAAA0C" />
      </linearGradient>
      <path id="icon-plank-gaming-a" d="M0 0h24v24H0z" />
      {/* end IconProviderPlankGaming */}

      {/* IconProviderEvolution */}
      <linearGradient
        id="icon-evo-0"
        x1="12.7287"
        y1="10.9549"
        x2="10.6279"
        y2="30.5619"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DBDE" />
        <stop offset="1" stopColor="#A8A8A8" />
      </linearGradient>
      <linearGradient
        id="icon-evo-1"
        x1="14.4294"
        y1="11.1365"
        x2="12.3286"
        y2="30.7445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9DBDE" />
        <stop offset="1" stopColor="#A8A8A8" />
      </linearGradient>
      <radialGradient
        id="icon-evo-2"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.80165 13.3648) scale(20.0267)"
      >
        <stop stopColor="#C2C2C2" />
        <stop offset="0.2167" stopColor="#BDBDBD" />
        <stop offset="0.4621" stopColor="#AFAFAF" />
        <stop offset="0.7215" stopColor="#999999" />
        <stop offset="0.989" stopColor="#797979" />
        <stop offset="1" stopColor="#787878" />
      </radialGradient>
      {/* end IconProviderEvolution */}

      {/* IconProviderGivme */}
      <path id="icon-provider-giveme-b" d="M0 0H24V24H0z" />
      <mask id="icon-provider-giveme-a" fill="#fff">
        <use xlinkHref="#icon-provider-giveme-b" />
      </mask>
      {/* end IconProviderGivme */}

      {/* IconProviderKalamba */}
      <path id="icon-provider-kalamba-a" d="M0 0H24V24H0z" />
      <mask id="icon-provider-kalamba-b" fill="#fff">
        <use xlinkHref="#icon-provider-kalamba-a" />
      </mask>
      {/* end IconProviderKalamba */}

      {/* IconProviderSpribeBig */}
      <path id="icon-provider-spribe-big-a" d="M0 0h141v78H0z" />
      {/* end IconProviderSpribeBig */}

      {/* IconProviderRelaxGamingBig */}
      <path id="icon-provider-relax-gaming-big-a" d="M0 0h141v78H0z" />
      {/* end IconProviderRelaxGamingBig */}

      {/* IconProviderBigTimeGaming */}
      <path id="bigtime-gaming" d="M0 0H24V24H0z" />
      {/* end IconProviderBigTimeGaming */}

      {/* IconProviderBigTimeGamingBig */}
      <path id="bigtime-gaming-big" d="M0 0H141V78H0z" />
      {/* end IconProviderBigTimeGamingBig */}

      {/* IconProviderOryx */}
      <path id="icon-provider-oryx-a" d="M0 0H24V24H0z" />
      <mask id="icon-provider-oryx-b" fill="#fff">
        <use xlinkHref="#icon-provider-oryx-a" />
      </mask>
      {/* end IconProviderOryx */}

      {/* IconProviderMicroGaming */}
      <linearGradient id="icon-provider-microgaming-a" x1="-7.767%" x2="395.78%" y1="64.039%" y2="-33.358%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      {/* end IconProviderMicroGaming */}

      {/* IconProviderTvbet */}
      <linearGradient id="icon-tvbet-0" x1="20.522%" x2="54.909%" y1="-12.8%" y2="58.959%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-1" x1="46.718%" x2="47.996%" y1="425.913%" y2="281.442%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-2" x1="48.104%" x2="48.922%" y1="320.984%" y2="205.145%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-3" x1="-10.722%" x2="9.439%" y1="1776.968%" y2="1209.576%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-4" x1="841.121%" x2="861.16%" y1="-60.944%" y2="-128.317%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-5" x1="60.515%" x2="68.758%" y1="789.74%" y2="444.6%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-6" x1="37.302%" x2="44.62%" y1="656.114%" y2="312.138%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-7" x1="42.575%" x2="45.444%" y1="616.227%" y2="400.115%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <path id="icon-tvbet-8" d="M0 0H141V78H0z" />
      {/* end IconProviderTvbet */}

      {/* IconProviderTvbetSmall */}
      <linearGradient id="icon-tvbet-small-0" x1="20.522%" x2="54.909%" y1="-12.8%" y2="58.959%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-1" x1="46.718%" x2="47.996%" y1="425.913%" y2="281.442%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-2" x1="48.104%" x2="48.922%" y1="320.984%" y2="205.145%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-3" x1="-10.722%" x2="9.439%" y1="1776.968%" y2="1209.576%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-4" x1="841.121%" x2="861.16%" y1="-60.944%" y2="-128.317%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-5" x1="60.515%" x2="68.758%" y1="789.74%" y2="444.6%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-6" x1="37.302%" x2="44.62%" y1="656.114%" y2="312.138%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <linearGradient id="icon-tvbet-small-7" x1="42.575%" x2="45.444%" y1="616.227%" y2="400.115%">
        <stop offset="0%" stopColor="#FECF08" />
        <stop offset="100%" stopColor="#F9A11E" />
      </linearGradient>
      <path id="icon-tvbet-small-8" d="M0 0H24V24H0z" />
      {/* end IconProviderTvbetSmall */}

      {/* IconInfoDeposit */}
      <linearGradient id="paint0_linear_8067_3644" x1="10" y1="0" x2="10" y2="20" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="clip0_8067_3644">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_8067_3644">
        <rect width="12" height="12" fill="white" transform="matrix(1 0 0 -1 4 15.9999)" />
      </clipPath>
      {/* end IconInfoDeposit */}

      {/* IconPJackpot start */}
      <linearGradient
        id="icon-jackpot-2"
        x1="19.3936"
        y1="7.46155"
        x2="19.3936"
        y2="1.00001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-3"
        x1="37.5741"
        y1="12.8461"
        x2="37.5741"
        y2="23.6154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-4"
        x1="37.5741"
        y1="12.8461"
        x2="37.5741"
        y2="23.6154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="icon-jackpot-5" x1="39.778" y1="8.53845" x2="39.778" y2="15" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="icon-jackpot-6" x1="19.3932" y1="14.1781" x2="19.3938" y2="43" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFAD10" />
        <stop offset="1" stopColor="#FFE5B9" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-7"
        x1="19.3935"
        y1="11.7692"
        x2="19.3935"
        y2="25.7692"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-8"
        x1="15.0834"
        y1="14.7491"
        x2="15.0844"
        y2="25.7692"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAD10" />
        <stop offset="1" stopColor="#FFE5B9" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-9"
        x1="23.2501"
        y1="14.7491"
        x2="23.2512"
        y2="25.7692"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAD10" />
        <stop offset="1" stopColor="#FFE5B9" />
      </linearGradient>
      <linearGradient
        id="icon-jackpot-10"
        x1="25.4538"
        y1="30.0769"
        x2="25.4538"
        y2="32.2307"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="icon-jackpot-1">
        <rect width="42" height="42" fill="white" transform="translate(2.25 1)" />
      </clipPath>
      {/* IconPJackpot end */}

      {/* IconProviderTomHornGaming */}
      <path
        id="icon-provider-tom-horn-gaming-a"
        d="M2.934 2.886C-.96 6.753-.981 13.044 2.886 16.937a1.856 1.856 0 0 1 2.632-2.616 6.224 6.224 0 0 1 8.833-8.773l.001.001a1.855 1.855 0 0 0 2.633-2.615A9.904 9.904 0 0 0 9.935 0a9.905 9.905 0 0 0-7.001 2.886"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-b" x1="75.739%" x2="26.541%" y1="34.044%" y2="64.625%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      <path
        id="icon-provider-tom-horn-gaming-d"
        d="M14.739 2.663c-.727.722-1.9.718-2.623-.008a6.225 6.225 0 0 1-8.833 8.773l-.02-.018a1.95 1.95 0 0 0-.122-.112l-.004-.002a1.835 1.835 0 0 0-.146-.108l-.01-.006a1.843 1.843 0 0 0-.148-.088l-.012-.006a1.86 1.86 0 0 0-1.713 0l-.053.032a1.846 1.846 0 0 0-.397.298 1.856 1.856 0 0 0-.009 2.624c3.867 3.893 10.158 3.915 14.051.048 3.893-3.867 3.915-10.158.048-14.05a1.856 1.856 0 0 1-.01 2.623"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-e" x1="25.551%" x2="73.503%" y1="65.221%" y2="35.325%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      {/* end IconProviderTomHornGaming */}

      {/* IconLevelAccomplished */}
      <linearGradient id="icon-level-accomplished-c" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#FF4949" />
        <stop offset="100%" stopColor="#FF0061" />
      </linearGradient>
      <rect id="icon-level-accomplished-b" width="48.96" height="48.96" x="3.84" y="5.76" rx="24.48" />
      <filter
        id="icon-level-accomplished-a"
        width="206.2%"
        height="206.2%"
        x="-53.1%"
        y="-26.6%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="13" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="6.5" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.309276661 0" />
      </filter>
      {/* end IconLevelAccomplished */}

      {/* IconLangRu */}
      <rect id="icon-lang-ru-a" width="30" height="24" rx="4" />
      <rect id="icon-lang-ru-c" width="30" height="24" rx="4" />
      <filter id="icon-lang-ru-d" width="116.7%" height="120.8%" x="-8.3%" y="-10.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
      </filter>
      <mask id="icon-lang-ru-b" fill="#fff">
        <use xlinkHref="#icon-lang-ru-a" />
      </mask>
      {/* end IconLangRu */}

      {/* IconLangEn */}
      <rect id="icon-lang-en-a" width="30" height="24" rx="4" />
      <rect id="icon-lang-en-c" width="30" height="24" rx="4" />
      <filter id="icon-lang-en-d" width="116.7%" height="120.8%" x="-8.3%" y="-10.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
      </filter>
      <mask id="icon-lang-en-b" fill="#fff">
        <use xlinkHref="#icon-lang-en-a" />
      </mask>
      {/* end IconLangEn */}

      {/* IconHabanero */}
      <linearGradient
        id="icon-habanero-0"
        x1="162.92"
        y1="560.637"
        x2="611.51"
        y2="560.637"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ED334D" />
        <stop offset="1" stopColor="#F79826" />
      </linearGradient>
      {/* end IconHabanero */}

      {/* IconProviderTomHornGamingBig */}
      <path
        id="icon-provider-tom-horn-gaming-big-a"
        d="M5.089 5.006c-6.753 6.707-6.79 17.618-.083 24.37A3.218 3.218 0 0 1 9.57 24.84c-4.2-4.23-4.176-11.065.054-15.266 4.23-4.202 11.064-4.179 15.267.05l.002.002a3.218 3.218 0 0 0 4.566-4.536A17.178 17.178 0 0 0 17.232 0 17.18 17.18 0 0 0 5.09 5.006"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-big-b" x1="75.739%" x2="26.541%" y1="34.044%" y2="64.625%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      <mask id="icon-provider-tom-horn-gaming-big-c" fill="#fff">
        <use xlinkHref="#icon-provider-tom-horn-gaming-big-a" />
      </mask>
      <path
        id="icon-provider-tom-horn-gaming-big-d"
        d="M25.564 4.62a3.218 3.218 0 0 1-4.549-.014c4.2 4.23 4.176 11.065-.054 15.266-4.23 4.201-11.064 4.179-15.266-.05l-.002-.002-.033-.03a3.383 3.383 0 0 0-.213-.194l-.007-.005a3.183 3.183 0 0 0-.253-.186l-.016-.01a3.197 3.197 0 0 0-.257-.153l-.022-.01a3.225 3.225 0 0 0-2.97 0c-.031.017-.061.037-.092.055a3.201 3.201 0 0 0-.688.517 3.218 3.218 0 0 0-.016 4.551c6.707 6.753 17.618 6.79 24.37.083 6.753-6.707 6.79-17.618.083-24.37a3.218 3.218 0 0 1-.015 4.551"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-big-e" x1="25.551%" x2="73.503%" y1="65.221%" y2="35.325%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      <mask id="icon-provider-tom-horn-gaming-big-f" fill="#fff">
        <use xlinkHref="#icon-provider-tom-horn-gaming-big-d" />
      </mask>
      {/* end IconProviderTomHornGamingBig */}

      {/* IconProvider1x2Gaming */}
      <linearGradient
        id="paint0_linear"
        x1="25.696"
        y1="39.2932"
        x2="25.696"
        y2="3.45488"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C4A49" />
        <stop offset="1" stopColor="#9B9A9C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="17.4517"
        y1="39.2189"
        x2="17.4517"
        y2="3.70684"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#242E23" />
        <stop offset="1" stopColor="#568759" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="25.696"
        y1="43.0591"
        x2="25.696"
        y2="7.54706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="329.942"
        y1="84303.6"
        x2="329.942"
        y2="85065.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" stopOpacity="0.3" />
      </linearGradient>
      {/* end IconProvider1x2Gaming */}

      {/* IconProvider1x2GamingBig */}
      <linearGradient x1="50.049%" y1="100.012%" x2="50.049%" y2="-12.862%" id="icon-provider-1x1-gaming-big-c">
        <stop stopColor="#4D4948" offset="0%" />
        <stop stopColor="#9D9B9D" offset="100%" />
      </linearGradient>
      <linearGradient x1="49.992%" y1="111.813%" x2="49.992%" y2=".014%" id="icon-provider-1x1-gaming-big-d">
        <stop stopColor="#192C1B" offset="0%" />
        <stop stopColor="#008D39" offset="100%" />
      </linearGradient>
      <linearGradient x1="50.049%" y1="111.847%" x2="50.049%" y2=".002%" id="icon-provider-1x1-gaming-big-f">
        <stop stopColor="#FFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFF" stopOpacity=".3" offset="100%" />
      </linearGradient>
      <linearGradient x1="49.992%" y1="111.818%" x2="49.992%" y2="-.027%" id="icon-provider-1x1-gaming-big-i">
        <stop stopColor="#FFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFF" stopOpacity=".3" offset="100%" />
      </linearGradient>
      <linearGradient x1="49.873%" y1="100.026%" x2="49.873%" y2="-.014%" id="icon-provider-1x1-gaming-big-k">
        <stop stopColor="#A19E9C" offset="0%" />
        <stop stopColor="#CCC9CA" offset="100%" />
      </linearGradient>
      <linearGradient x1="50.013%" y1="100.038%" x2="50.013%" y2="-.081%" id="icon-provider-1x1-gaming-big-l">
        <stop stopColor="#A19E9C" offset="0%" />
        <stop stopColor="#CCC9CA" offset="100%" />
      </linearGradient>
      <linearGradient x1="50.007%" y1="100%" x2="50.007%" y2="0%" id="icon-provider-1x1-gaming-big-n">
        <stop stopColor="#A19E9C" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
      <linearGradient x1="50.411%" y1="99.898%" x2="50.411%" y2=".017%" id="icon-provider-1x1-gaming-big-q">
        <stop stopColor="#A19E9C" offset="0%" />
        <stop stopColor="#FFF" offset="100%" />
      </linearGradient>
      <linearGradient x1="49.972%" y1="99.894%" x2="49.972%" y2=".033%" id="icon-provider-1x1-gaming-big-s">
        <stop stopColor="#C6C3C2" offset="0%" />
        <stop stopColor="#ECE9EB" offset="100%" />
      </linearGradient>
      <linearGradient x1="49.991%" y1="100.05%" x2="49.991%" y2=".034%" id="icon-provider-1x1-gaming-big-u">
        <stop stopColor="#C6C3C2" stopOpacity=".4" offset="20%" />
        <stop stopColor="#FFF" stopOpacity=".7" offset="70%" />
      </linearGradient>
      <path id="icon-provider-1x1-gaming-big-a" d="M0 0h141v78H0z" />
      <path
        d="M21.437 18.455l6.253-8.642h-.913l3.773-5.462a19.308 19.308 0 014.808 5.98c-.821-.411-1.993-.685-3.651-.685-4.412 0-5.34 2.404-5.34 4.443l.015 3.073c0 .243.137.471.365.578a.654.654 0 00.685-.06l3.59-2.618a.657.657 0 00.274-.517l.015-1.415c0-.198-.03-.274.365-.274.548 0 .533.152.533.335v1.84c0 .016-.015.427-1.324 1.507l-2.784 2.16a.16.16 0 01-.076.03c-1.141 1.05-1.75 2.1-1.75 3.135v.73l-2.54-.836-2.298-3.302zm15.534 4.9c.32-1.385.563-2.83.563-4.307 0-1.217-.122-2.403-.274-3.56v.061c0 1.004-.639 2.008-1.81 2.982 0 0-.03.015-.046.015l-2.784 2.115c-.837.73-1.263 1.4-1.263 1.993v.441l5.127.016c.183 0 .365.09.487.243zM2.586 12.703h-.928c-.365 0-.608-.213-.608-.578v-.822c-.457.776-.685 1.567-.928 2.389l3.21 1.11v-1.43c-.015-.41.03-.669-.746-.669zm11.776-2.997l.061.06 3.728 5.28 3.94-5.401h1.096l5.081-6.907C25.393.989 22.015 0 18.394 0 11.304 0 5.112 4.032 1.841 9.661h3.362c2.587 0 4.047 1.37 4.047 4.032v3.088l6.147 2.115-6.512-9.25h.502c4.9 0 4.9 0 4.975.06z"
        id="icon-provider-1x1-gaming-big-e"
      />
      <path
        d="M21.437 18.455l6.253-8.642h-.913l3.773-5.462a19.308 19.308 0 014.808 5.98c-.821-.411-1.993-.685-3.651-.685-4.412 0-5.34 2.404-5.34 4.443l.015 3.073c0 .243.137.471.365.578a.654.654 0 00.685-.06l3.59-2.618a.657.657 0 00.274-.517l.015-1.415c0-.198-.03-.274.365-.274.548 0 .533.152.533.335v1.84c0 .016-.015.427-1.324 1.507l-2.784 2.16a.16.16 0 01-.076.03c-1.141 1.05-1.75 2.1-1.75 3.135v.73l-2.54-.836-2.298-3.302zm15.534 4.9c.32-1.385.563-2.83.563-4.307 0-1.217-.122-2.403-.274-3.56v.061c0 1.004-.639 2.008-1.81 2.982 0 0-.03.015-.046.015l-2.784 2.115c-.837.73-1.263 1.4-1.263 1.993v.441l5.127.016c.183 0 .365.09.487.243zM2.586 12.703h-.928c-.365 0-.608-.213-.608-.578v-.822c-.457.776-.685 1.567-.928 2.389l3.21 1.11v-1.43c-.015-.41.03-.669-.746-.669zm11.776-2.997l.061.06 3.728 5.28 3.94-5.401h1.096l5.081-6.907C25.393.989 22.015 0 18.394 0 11.304 0 5.112 4.032 1.841 9.661h3.362c2.587 0 4.047 1.37 4.047 4.032v3.088l6.147 2.115-6.512-9.25h.502c4.9 0 4.9 0 4.975.06z"
        id="icon-provider-1x1-gaming-big-h"
      />
      <path id="icon-provider-1x1-gaming-big-m" d="M0 16.355l44.639 15.23-1.46-25.012L26.578 0 8.11 2.115z" />
      <path id="icon-provider-1x1-gaming-big-p" d="M0 16.355l44.639 15.23-1.46-25.012L26.578 0 8.11 2.115z" />
      <path id="icon-provider-1x1-gaming-big-t" d="M65.285 13.769L.06 9.965 2.51 3.15 40.302.122l23.871 5.005z" />
      {/* end IconProvider1x2GamingBig */}

      {/* IconNewLevelBg */}
      <path id="icon-new-level-bg-a" d="M0 0h480v497H0z" />
      <radialGradient
        id="icon-new-level-bg-b"
        r="43.364%"
        fx="50%"
        fy="50%"
        gradientTransform="rotate(76.658 .52 .516) scale(1 1.06329)"
      >
        <stop offset="0%" stopColor="#88B5FF" stopOpacity=".117" />
        <stop offset="60.037%" stopColor="#88CEFF" stopOpacity=".022" />
        <stop offset="100%" stopColor="#188FC0" stopOpacity="0" />
      </radialGradient>
      <mask id="icon-new-level-bg-c" fill="#fff">
        <use xlinkHref="#icon-new-level-bg-a" />
      </mask>
      {/* end IconNewLevelBg */}

      {/* IconProviderMicrogamingBig */}
      <linearGradient id="icon-provider-microgaming-big-a" x1="-7.767%" x2="395.78%" y1="63.987%" y2="-33.053%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-b" x1="-290.435%" x2="735.678%" y1="137.578%" y2="-126.761%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-c" x1="-6.152%" x2="136.848%" y1="154.043%" y2="-110.957%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-d" x1="-428.191%" x2="671.809%" y1="194.521%" y2="-136.729%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-e" x1="-330.428%" x2="441.611%" y1="212.318%" y2="-125.261%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-f" x1="-579.992%" x2="580.165%" y1="229.833%" y2="-101.418%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-g" x1="-331.436%" x2="297.049%" y1="201.26%" y2="-48.152%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-h" x1="-700.343%" x2="407.936%" y1="276.945%" y2="-54.258%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-i" x1="-736.15%" x2="291.888%" y1="189.873%" y2="7.488%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-j" x1="-68.999%" x2="74.001%" y1="270.531%" y2="5.532%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-k" x1="-956.172%" x2="191.461%" y1="345.609%" y2="9.228%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      <linearGradient id="icon-provider-microgaming-big-l" x1="-541.234%" x2="87.251%" y1="284.484%" y2="35.072%">
        <stop offset="0%" stopColor="#21E418" />
        <stop offset="30%" stopColor="#31B6E9" />
        <stop offset="97.57%" stopColor="#21E418" />
      </linearGradient>
      {/* end IconProviderMicrogamingBig */}

      {/* IconProviderEzugiBig */}
      <linearGradient id="icon-provider-ezugi-big-a" x1="76.39%" x2="38.905%" y1="-3.26%" y2="97.494%">
        <stop offset="0%" stopColor="#70ABDC" />
        <stop offset="17%" stopColor="#67A6DA" />
        <stop offset="46%" stopColor="#4D9AD4" />
        <stop offset="60%" stopColor="#3E93D0" />
        <stop offset="99%" stopColor="#1B7CC1" />
      </linearGradient>
      <linearGradient id="icon-provider-ezugi-big-b" x1="50.066%" x2="49.937%" y1=".035%" y2="100.045%">
        <stop offset="0%" stopColor="#3E93D0" />
        <stop offset="99%" stopColor="#1B7CC1" />
      </linearGradient>
      {/* end IconProviderEzugiBig */}

      {/* IconProviderAmusnetEgtBig */}
      <style>{'.icon-provider-amusnet-egt-big-a,.icon-provider-amusnet-egt-big-b{fill:#a6ce39;}.icon-provider-amusnet-egt-big-b{fill-rule:evenodd;}'}</style>
      {/* end IconProviderAmusnetEgtBig */}

      {/* IconProviderAmusnetEgt */}
      <linearGradient
        id="icon-egt-0"
        x1="35.3874"
        y1="-0.319245"
        x2="16.7272"
        y2="32.0148"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A48B" />
        <stop offset="1" stopColor="#A5CD39" />
      </linearGradient>
      <linearGradient id="icon-egt-1" x1="27.54" y1="17.8953" x2="20.6516" y2="5.96927" gradientUnits="userSpaceOnUse">
        <stop stopColor="#91C73E" />
        <stop offset="1" stopColor="#0092C0" />
      </linearGradient>
      {/* end IconProviderAmusnetEgt */}

      {/* IconProviderEvolutionBig */}
      <linearGradient id="icon-provider-evolution-big-a" x1="49.347%" x2="40.954%" y1="56.696%" y2="109.321%">
        <stop offset="0%" stopColor="#D9DBDE" />
        <stop offset="100%" stopColor="#A8A8A8" />
      </linearGradient>
      <linearGradient id="icon-provider-evolution-big-b" x1="56.138%" x2="47.745%" y1="9.091%" y2="61.739%">
        <stop offset="0%" stopColor="#D9DBDE" />
        <stop offset="100%" stopColor="#A8A8A8" />
      </linearGradient>
      <radialGradient
        id="icon-provider-evolution-big-c"
        cx="30.19%"
        cy="52.244%"
        r="92.771%"
        fx="30.19%"
        fy="52.244%"
        gradientTransform="matrix(1 0 0 .84792 0 .08)"
      >
        <stop offset="0%" stopColor="#C2C2C2" />
        <stop offset="22%" stopColor="#BDBDBD" />
        <stop offset="46%" stopColor="#B0B0B0" />
        <stop offset="72%" stopColor="#999" />
        <stop offset="99%" stopColor="#7A7A7A" />
        <stop offset="100%" stopColor="#787878" />
      </radialGradient>
      {/* end IconProviderEvolutionBig */}

      {/* IconProviderTomHornGamingBig */}
      <path
        id="icon-provider-tom-horn-gaming-big-a"
        d="M5.089 5.006c-6.753 6.707-6.79 17.618-.083 24.37A3.218 3.218 0 0 1 9.57 24.84c-4.2-4.23-4.176-11.065.054-15.266 4.23-4.202 11.064-4.179 15.267.05l.002.002a3.218 3.218 0 0 0 4.566-4.536A17.178 17.178 0 0 0 17.232 0 17.18 17.18 0 0 0 5.09 5.006"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-big-b" x1="75.739%" x2="26.541%" y1="34.044%" y2="64.625%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      <mask id="icon-provider-tom-horn-gaming-big-c" fill="#fff">
        <use xlinkHref="#icon-provider-tom-horn-gaming-big-a" />
      </mask>
      <path
        id="icon-provider-tom-horn-gaming-big-d"
        d="M25.564 4.62a3.218 3.218 0 0 1-4.549-.014c4.2 4.23 4.176 11.065-.054 15.266-4.23 4.201-11.064 4.179-15.266-.05l-.002-.002-.033-.03a3.383 3.383 0 0 0-.213-.194l-.007-.005a3.183 3.183 0 0 0-.253-.186l-.016-.01a3.197 3.197 0 0 0-.257-.153l-.022-.01a3.225 3.225 0 0 0-2.97 0c-.031.017-.061.037-.092.055a3.201 3.201 0 0 0-.688.517 3.218 3.218 0 0 0-.016 4.551c6.707 6.753 17.618 6.79 24.37.083 6.753-6.707 6.79-17.618.083-24.37a3.218 3.218 0 0 1-.015 4.551"
      />
      <linearGradient id="icon-provider-tom-horn-gaming-big-e" x1="25.551%" x2="73.503%" y1="65.221%" y2="35.325%">
        <stop offset="0%" stopColor="#C7E3F8" />
        <stop offset="28%" stopColor="#26B1E7" />
        <stop offset="100%" stopColor="#223B86" />
      </linearGradient>
      <mask id="icon-provider-tom-horn-gaming-big-f" fill="#fff">
        <use xlinkHref="#icon-provider-tom-horn-gaming-big-d" />
      </mask>
      {/* end IconProviderTomHornGamingBig */}

      {/* IconProviderBooongoBig */}
      <linearGradient id="icon-provider-booongo-big-a" x1="-1.391%" x2="99.587%" y1="50.032%" y2="50.032%">
        <stop offset="0%" stopColor="#68F28B" />
        <stop offset="100%" stopColor="#00FFDE" />
      </linearGradient>
      {/* end IconProviderBooongoBig */}

      {/* IconProvider1x2GamingBig */}
      <linearGradient id="icon-provider-1x2gaming-big-a" x1="50.049%" x2="50.049%" y1="100.012%" y2="-12.862%">
        <stop offset="0%" stopColor="#4D4948" />
        <stop offset="100%" stopColor="#9D9B9D" />
      </linearGradient>
      <linearGradient id="icon-provider-1x2gaming-big-b" x1="49.992%" x2="49.992%" y1="111.813%" y2=".014%">
        <stop offset="0%" stopColor="#192C1B" />
        <stop offset="100%" stopColor="#008D39" />
      </linearGradient>
      <path
        id="icon-provider-1x2gaming-big-c"
        d="M21.437 18.455l6.253-8.642h-.913l3.773-5.462a19.308 19.308 0 0 1 4.808 5.98c-.821-.411-1.993-.685-3.651-.685-4.412 0-5.34 2.404-5.34 4.443l.015 3.073c0 .243.137.471.365.578a.654.654 0 0 0 .685-.06l3.59-2.618a.657.657 0 0 0 .274-.517l.015-1.415c0-.198-.03-.274.365-.274.548 0 .533.152.533.335v1.84c0 .016-.015.427-1.324 1.507l-2.784 2.16a.16.16 0 0 1-.076.03c-1.141 1.05-1.75 2.1-1.75 3.135v.73l-2.54-.836-2.298-3.302zm15.534 4.9c.32-1.385.563-2.83.563-4.307 0-1.217-.122-2.403-.274-3.56v.061c0 1.004-.639 2.008-1.81 2.982 0 0-.03.015-.046.015l-2.784 2.115c-.837.73-1.263 1.4-1.263 1.993v.441l5.127.016c.183 0 .365.09.487.243zM2.586 12.703h-.928c-.365 0-.608-.213-.608-.578v-.822c-.457.776-.685 1.567-.928 2.389l3.21 1.11v-1.43c-.015-.41.03-.669-.746-.669zm11.776-2.997l.061.06 3.728 5.28 3.94-5.401h1.096l5.081-6.907C25.393.989 22.015 0 18.394 0 11.304 0 5.112 4.032 1.841 9.661h3.362c2.587 0 4.047 1.37 4.047 4.032v3.088l6.147 2.115-6.512-9.25h.502c4.9 0 4.9 0 4.975.06z"
      />
      <linearGradient id="icon-provider-1x2gaming-big-d" x1="50.049%" x2="50.049%" y1="111.847%" y2=".002%">
        <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
      </linearGradient>
      <mask id="icon-provider-1x2gaming-big-e" fill="#fff">
        <use xlinkHref="#icon-provider-1x2gaming-big-c" />
      </mask>
      <path
        id="icon-provider-1x2gaming-big-f"
        d="M21.437 18.455l6.253-8.642h-.913l3.773-5.462a19.308 19.308 0 0 1 4.808 5.98c-.821-.411-1.993-.685-3.651-.685-4.412 0-5.34 2.404-5.34 4.443l.015 3.073c0 .243.137.471.365.578a.654.654 0 0 0 .685-.06l3.59-2.618a.657.657 0 0 0 .274-.517l.015-1.415c0-.198-.03-.274.365-.274.548 0 .533.152.533.335v1.84c0 .016-.015.427-1.324 1.507l-2.784 2.16a.16.16 0 0 1-.076.03c-1.141 1.05-1.75 2.1-1.75 3.135v.73l-2.54-.836-2.298-3.302zm15.534 4.9c.32-1.385.563-2.83.563-4.307 0-1.217-.122-2.403-.274-3.56v.061c0 1.004-.639 2.008-1.81 2.982 0 0-.03.015-.046.015l-2.784 2.115c-.837.73-1.263 1.4-1.263 1.993v.441l5.127.016c.183 0 .365.09.487.243zM2.586 12.703h-.928c-.365 0-.608-.213-.608-.578v-.822c-.457.776-.685 1.567-.928 2.389l3.21 1.11v-1.43c-.015-.41.03-.669-.746-.669zm11.776-2.997l.061.06 3.728 5.28 3.94-5.401h1.096l5.081-6.907C25.393.989 22.015 0 18.394 0 11.304 0 5.112 4.032 1.841 9.661h3.362c2.587 0 4.047 1.37 4.047 4.032v3.088l6.147 2.115-6.512-9.25h.502c4.9 0 4.9 0 4.975.06z"
      />
      <linearGradient id="g" x1="49.992%" x2="49.992%" y1="111.818%" y2="-.027%">
        <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#FFF" stopOpacity=".3" />
      </linearGradient>
      <mask id="icon-provider-1x2gaming-big-h" fill="#fff">
        <use xlinkHref="#icon-provider-1x2gaming-big-f" />
      </mask>
      <linearGradient id="icon-provider-1x2gaming-big-i" x1="49.873%" x2="49.873%" y1="100.026%" y2="-.014%">
        <stop offset="0%" stopColor="#A19E9C" />
        <stop offset="100%" stopColor="#CCC9CA" />
      </linearGradient>
      <linearGradient id="icon-provider-1x2gaming-big-j" x1="50.013%" x2="50.013%" y1="100.038%" y2="-.081%">
        <stop offset="0%" stopColor="#A19E9C" />
        <stop offset="100%" stopColor="#CCC9CA" />
      </linearGradient>
      <path id="icon-provider-1x2gaming-big-k" d="M0 16.355l44.639 15.23-1.46-25.012L26.578 0 8.11 2.115z" />
      <linearGradient id="icon-provider-1x2gaming-big-l" x1="50.007%" x2="50.007%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#A19E9C" />
        <stop offset="100%" stopColor="#FFF" />
      </linearGradient>
      <mask id="icon-provider-1x2gaming-big-m" fill="#fff">
        <use xlinkHref="#icon-provider-1x2gaming-big-k" />
      </mask>
      <path id="icon-provider-1x2gaming-big-n" d="M0 16.355l44.639 15.23-1.46-25.012L26.578 0 8.11 2.115z" />
      <linearGradient id="icon-provider-1x2gaming-big-o" x1="50.411%" x2="50.411%" y1="99.898%" y2=".017%">
        <stop offset="0%" stopColor="#A19E9C" />
        <stop offset="100%" stopColor="#FFF" />
      </linearGradient>
      <mask id="icon-provider-1x2gaming-big-p" fill="#fff">
        <use xlinkHref="#icon-provider-1x2gaming-big-n" />
      </mask>
      <linearGradient id="icon-provider-1x2gaming-big-q" x1="49.972%" x2="49.972%" y1="99.894%" y2=".033%">
        <stop offset="0%" stopColor="#C6C3C2" />
        <stop offset="100%" stopColor="#ECE9EB" />
      </linearGradient>
      <path id="icon-provider-1x2gaming-big-r" d="M65.285 13.769L.06 9.965 2.51 3.15 40.302.122l23.871 5.005z" />
      <linearGradient id="icon-provider-1x2gaming-big-s" x1="49.991%" x2="49.991%" y1="100.05%" y2=".034%">
        <stop offset="20%" stopColor="#C6C3C2" stopOpacity=".4" />
        <stop offset="70%" stopColor="#FFF" stopOpacity=".7" />
      </linearGradient>
      <mask id="icon-provider-1x2gaming-big-t" fill="#fff">
        <use xlinkHref="#icon-provider-1x2gaming-big-r" />
      </mask>
      {/* end IconProvider1x2GamingBig */}

      {/* IconProviderHabaneroBig */}
      <linearGradient id="icon-provider-habanero-big-a" x1="-778.732%" x2="704.155%" y1="49.985%" y2="49.985%">
        <stop offset="0%" stopColor="#FA142E" />
        <stop offset="100%" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient id="icon-provider-habanero-big-b" x1="-524.436%" x2="945.422%" y1="49.986%" y2="49.986%">
        <stop offset="0%" stopColor="#FA142E" />
        <stop offset="100%" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient id="icon-provider-habanero-big-c" x1="-556.925%" x2="916.91%" y1="50.793%" y2="50.793%">
        <stop offset="0%" stopColor="#FA142E" />
        <stop offset="100%" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient id="icon-provider-habanero-big-d" x1="-965.702%" x2="496.83%" y1="50.036%" y2="50.036%">
        <stop offset="0%" stopColor="#FA142E" />
        <stop offset="100%" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient id="icon-provider-habanero-big-e" x1="-.005%" x2="100.014%" y1="50.055%" y2="50.055%">
        <stop offset="0%" stopColor="#FA142E" />
        <stop offset="100%" stopColor="#FF870D" />
      </linearGradient>
      {/* end IconProviderHabaneroBig */}

      {/* IconProviderRedrakeBig */}
      <linearGradient id="icon-provider-redrake-big-a" x1="25.765%" x2="48.392%" y1="51.844%" y2="49.955%">
        <stop offset="0%" stopColor="#831622" />
        <stop offset="100%" stopColor="#DB1D31" />
      </linearGradient>
      <linearGradient id="icon-provider-redrake-big-b" x1="23.305%" x2="78.458%" y1="54.437%" y2="47.509%">
        <stop offset="0%" stopColor="#231F20" />
        <stop offset="100%" stopColor="#424243" />
      </linearGradient>
      {/* end IconProviderRedrakeBig */}

      {/* IconProviderBetsoftBig */}
      <path id="icon-provider-betsoft-big-a" d="M0 0h100v37.487H0z" />
      <mask id="icon-provider-betsoft-big-b" fill="#fff">
        <use xlinkHref="#icon-provider-betsoft-big-a" />
      </mask>
      {/* end IconProviderBetsoftBig */}

      {/* IconClock */}
      <linearGradient id="icon-clock" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.white} />
        <stop offset="100%" stopColor={colors.white} />
      </linearGradient>
      <linearGradient id="icon-clock-active" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>
      {/* end IconClock */}

      {/* IconProviderOryx */}
      <path id="icon-provider-oryx-a" d="M0 0H24V24H0z" />
      <mask id="icon-provider-oryx-b" fill="#fff">
        <use xlinkHref="#icon-provider-oryx-a" />
      </mask>
      {/* end IconProviderOryx */}

      {/* IconMenu */}
      <clipPath id="icon-menu-0">
        <path fill="#fff" d="M0 0h320v568H0z" transform="translate(-15 -16)" />
      </clipPath>
      {/* end IconMenu */}

      {/* IconPwaLogo */}
      <linearGradient id="icon-pwa-logo-b" x1="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#F41A4F" />
        <stop offset="100%" stopColor="#FF4949" />
      </linearGradient>
      <rect id="icon-pwa-logo-a" width="78" height="78" rx="16" />
      <radialGradient
        id="icon-pwa-logo-c"
        r="172.947%"
        fx="50%"
        fy="50%"
        gradientTransform="rotate(67.25 .524 .516) scale(1 1.06329)"
      >
        <stop offset="0%" stopColor="#FFF" stopOpacity=".155" />
        <stop offset="23.841%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#C09218" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-pwa-logo-e" x1="50%" x2="50%" y1="0%" y2="98.781%">
        <stop offset="0%" stopColor="#FFE424" />
        <stop offset="100%" stopColor="#FFC30E" />
      </linearGradient>
      <mask id="icon-pwa-logo-d" fill="#fff">
        <use xlinkHref="#icon-pwa-logo-a" />
      </mask>
      {/* end IconPwaLogo */}

      {/* IconChrome */}
      <linearGradient id="icon-chrome-a" x1="49.941%" x2="49.941%" y1=".144%" y2="100.032%">
        <stop offset="0%" stopColor="#81B4E0" />
        <stop offset="100%" stopColor="#0C5A94" />
      </linearGradient>
      <linearGradient id="icon-chrome-b" x1="50%" x2="50%" y1=".137%" y2="71.693%">
        <stop offset="0%" stopColor="#F06B59" />
        <stop offset="100%" stopColor="#DF2227" />
      </linearGradient>
      <linearGradient id="icon-chrome-c" x1="26.279%" x2="49.134%" y1="81.958%" y2="38.282%">
        <stop offset="0%" stopColor="#388B41" />
        <stop offset="100%" stopColor="#4CB749" />
      </linearGradient>
      <linearGradient id="icon-chrome-d" x1="58.422%" x2="35.677%" y1="85.352%" y2="12.208%">
        <stop offset="0%" stopColor="#E4B022" />
        <stop offset="30%" stopColor="#FCD209" />
      </linearGradient>
      <linearGradient id="icon-chrome-e" x1="49.999%" x2="49.999%" y1="96.296%" y2="-2.466%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      <linearGradient id="icon-chrome-f" x1="71.06%" x2="28.821%" y1="8.54%" y2="78.539%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      <linearGradient id="icon-chrome-g" x1="39.927%" x2="47.694%" y1="66.865%" y2="52.759%">
        <stop offset="0%" stopOpacity=".15" />
        <stop offset="30%" stopOpacity=".06" />
        <stop offset="100%" stopOpacity=".03" />
      </linearGradient>
      {/* end IconChrome */}

      {/* IconSmallMinDeposit */}
      <linearGradient id="icon-min-deposit-a" x1="59.783%" x2="106.282%" y1="-67.372%" y2="125.631%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSmallMinDeposit */}

      {/* IconSecurePayments */}
      <linearGradient id="icon-secure-payments-a" x1="56.601%" x2="87.976%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSecurePayments */}

      {/* IconSupport */}
      <linearGradient id="icon-support-a" x1="59.783%" x2="106.282%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSupport */}

      {/* IconVisa Promo */}
      <linearGradient id="icon-visa-payment-promo-a" x1="0%" y1="49.187%" y2="50.555%">
        <stop offset="0%" stopColor="#242867" />
        <stop offset="100%" stopColor="#2041A1" />
      </linearGradient>
      <path
        id="icon-visa-payment-promo-b"
        d="M42.366 0c1.61-.007 3.208.282 4.716.854l-.715 4.328-.476-.213a9.042 9.042 0 0 0-3.916-.767c-2.075 0-3.005.871-3.027 1.725 0 .938 1.125 1.556 2.964 2.472 3.029 1.43 4.433 3.177 4.413 5.459-.043 4.155-3.633 6.842-9.15 6.842-2.358-.022-4.63-.514-5.863-1.068l.736-4.497.693.321c1.708.747 2.832 1.065 4.931 1.065 1.515 0 3.136-.619 3.158-1.96 0-.874-.691-1.515-2.725-2.495-1.99-.96-4.65-2.558-4.607-5.436.021-3.9 3.677-6.63 8.868-6.63zM31.314.364L28.026 20.4h-5.257L26.057.364h5.257zm29.243 0L64.8 20.4h-4.868s-.477-2.302-.627-3.007h-6.75l-1.104 3.007h-5.515l7.806-18.374c.541-1.3 1.495-1.663 2.749-1.663h4.066zm-42.18 0v.002h5.56l-8.263 20.016h-5.558L5.59 3.562C3.962 2.602 2.095 1.832 0 1.3L.086.9h8.35c1.132.042 2.05.402 2.349 1.67l1.534 7.714c.136.326.253.652.35.975l.56 2.771L18.379.364zm38.481 5.414c-.26.745-.713 1.962-.691 1.918 0 0-1.665 4.457-2.1 5.607h4.37c-.216-1.002-1.212-5.8-1.212-5.8z"
      />
      {/* end IconVisa */}

      {/* IconSkrill Promo */}
      <path
        id="icon-skrill-payment-promo-a"
        d="M49.384 2.035l5.166-.903v19.36h-5.166V2.035zm7.545 0v18.457H62.1V1.132l-5.171.903zM42.023 20.492h5.17V6.332h-5.17v14.16zM7.859 8.334c-.653-.042-2.166-.137-2.166-1.466 0-1.604 2.178-1.604 2.995-1.604 1.436 0 3.296.414 4.625.802 0 0 .74.255 1.371.516l.06.016V2.205l-.081-.023c-1.568-.535-3.391-1.05-6.77-1.05C2.064 1.132 0 4.445 0 7.283c0 1.636.719 5.487 7.392 5.93.566.035 2.068.119 2.068 1.493 0 1.134-1.23 1.802-3.297 1.802-2.266 0-4.464-.564-5.799-1.098v4.523c1.999.512 4.252.767 6.892.767 5.698 0 8.25-3.135 8.25-6.241 0-3.523-2.856-5.812-7.647-6.125zm31.25-2.21c-4.778.15-7.203 2.242-7.203 6.4v7.968h5.212v-6.497c0-2.49.334-3.558 3.362-3.66V6.197c-.509-.105-1.37-.073-1.37-.073zm-14.024.192c-.115.282-.942 2.564-2.944 4.929V1.132L16.806 2.16v18.33h5.335v-5.666c1.545 2.262 2.307 5.667 2.307 5.667h6.39c-.632-2.565-3.397-7.293-3.397-7.293 2.482-3.07 3.571-6.341 3.745-6.883h-6.1zm19.522-1.343c1.407 0 2.549-1.113 2.549-2.486 0-1.373-1.142-2.487-2.55-2.487C43.2 0 42.06 1.114 42.06 2.487s1.14 2.486 2.547 2.486z"
      />
      <linearGradient id="icon-skrill-payment-promo-a" x1="59.783%" x2="106.282%" y1="-79.402%" y2="133.384%">
        <stop offset="0%" stopColor="#61B8FF" />
        <stop offset="14.168%" stopColor="#2793F9" />
        <stop offset="100%" stopColor="#0047FF" />
      </linearGradient>
      {/* end IconSkrill */}

      {/* IconStarFilled */}
      <linearGradient id="icon-star-gradient" x1="49.956%" x2="50%" y1="-17.297%" y2="100%">
        <stop offset="0%" stopColor="#FFE211" />
        <stop offset="25.845%" stopColor="#FFE211" />
        <stop offset="100%" stopColor="#FFC107" />
      </linearGradient>
      {/* end IconStarFilled */}

      {/* IconChat Primary */}
      <linearGradient id="icon-chat-a-primary" x1="37.811%" x2="65.855%" y1="108.808%" y2="5.401%">
        <stop offset="0%" stopColor={colors.razzmatazz} />
        <stop offset="100%" stopColor={colors.sunsetOrange} />
      </linearGradient>
      {/* IconChat Primary */}

      {/* IconChat Secondary */}
      <linearGradient id="icon-chat-a-secondary" x1="76.534%" x2="65.879%" y1="-34.715%" y2="128.067%">
        <stop offset="0%" stopColor="#25A1FF" />
        <stop offset="100%" stopColor="#2800FF" />
      </linearGradient>
      {/* end IconChat Secondary */}

      {/* IconFormulaSpin */}
      <clipPath id="clip0_685_1729">
        <rect width="60" height="60" fill="white" />
      </clipPath>
      {/* end  IconFormulaSpin */}

      {/* IconShine */}
      <radialGradient
        id="icon-shine-a"
        cx="50.516%"
        cy="50.443%"
        r="27.158%"
        fx="50.516%"
        fy="50.443%"
        gradientTransform="matrix(0 1 -1.11006 0 1.065 0)"
      >
        <stop offset="0%" stopColor="#FFF" stopOpacity=".117" />
        <stop offset="59.816%" stopColor="#FFF" stopOpacity=".022" />
        <stop offset="100%" stopColor="#FFF" stopOpacity="0" />
      </radialGradient>
      {/* end IconShine */}

      {/* IconShineLarge */}
      <radialGradient
        id="icon-shine-large-a"
        r="132.317%"
        fx="50%"
        fy="50%"
        gradientTransform="rotate(67.131 .524 .516) scale(1 1.06329)"
      >
        <stop offset="0%" stopColor="#FFF" stopOpacity=".027" />
        <stop offset="14.213%" stopColor="#FFCFBD" stopOpacity=".105" />
        <stop offset="25.681%" stopColor="#FFF" stopOpacity="0" />
        <stop offset="100%" stopColor="#C09218" stopOpacity="0" />
      </radialGradient>
      {/* end IconShineLarge */}

      {/* IconWithdrawalDeny */}
      <linearGradient id="icon-withdrawal-deny-a" x1="189.129%" x2="10.9%" y1="-57.338%" y2="86.125%">
        <stop offset="0%" stopColor="#00DD61" />
        <stop offset="100%" stopColor="#006E3A" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-b" x1="10.776%" x2="72.022%" y1="0%" y2="97.444%">
        <stop offset="0%" stopColor="#00DD61" />
        <stop offset="100%" stopColor="#00A056" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-c" x1="59.628%" x2="35.12%" y1="100%" y2="-10.283%">
        <stop offset="0%" stopColor="#CCFFDA" stopOpacity="0" />
        <stop offset="100%" stopColor="#C9FFD7" stopOpacity=".776" />
        <stop offset="100%" stopColor="#61FFA2" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-d" x1="-3.342%" x2="95.223%" y1="48.796%" y2="52.814%">
        <stop offset="0%" stopColor="#FFAC43" />
        <stop offset="84.591%" stopColor="#A34600" />
        <stop offset="100%" stopColor="#A37F00" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-deny-e" x1="-3.342%" x2="95.223%" y1="49.116%" y2="52.067%">
        <stop offset="0%" stopColor="#FFF27D" />
        <stop offset="100%" stopColor="#FF9800" />
      </linearGradient>
      {/* end  IconWithdrawalDeny */}

      {/* IconGiftGray */}
      <linearGradient x1="57.6121636%" y1="13.5754779%" x2="92.1876894%" y2="105.19282%" id="icon-gift-gray-1">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#212126" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="125.661507%" x2="50%" y2="2.07981419%" id="icon-gift-gray-2">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0.0643848339" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="2.32073848%" x2="50%" y2="100%" id="icon-gift-gray-3">
        <stop stopColor="#212126" stopOpacity="0.7" offset="0%" />
        <stop stopColor="#212126" stopOpacity="0" offset="100%" />
      </linearGradient>
      <linearGradient x1="59.866574%" y1="0%" x2="59.866574%" y2="86.1988367%" id="icon-gift-gray-4">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#212126" offset="100%" />
      </linearGradient>
      <linearGradient x1="40.8125493%" y1="48.2421875%" x2="77.8540278%" y2="54.5518498%" id="icon-gift-gray-5">
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#313137" offset="0%" />
        <stop stopColor="#2C2C32" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="100%" x2="50%" y2="2.07981419%" id="icon-gift-gray-6">
        <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
        <stop stopColor="#FFFFFF" stopOpacity="0.0370137675" offset="100%" />
      </linearGradient>
      {/* end IconGiftGray */}

      {/* IconGift */}
      <radialGradient
        id="icon-gift-a"
        r="162.482%"
        fx="50%"
        fy="50%"
        gradientTransform="rotate(67.41 .5 .5) scale(1 1.00179)"
      >
        <stop offset="0%" stopColor="#FFDAB2" stopOpacity="0" />
        <stop offset="6.654%" stopColor="#FFDAB2" stopOpacity=".32" />
        <stop offset="25.715%" stopColor="#FFDAB2" stopOpacity="0" />
        <stop offset="99.834%" stopColor="#FFDAB2" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-b" x1="50%" x2="50%" y1="4.445%" y2="97.809%">
        <stop offset="0%" stopColor="#FF955F" />
        <stop offset="100%" stopColor="#FFD192" />
      </linearGradient>
      <linearGradient id="icon-gift-c" x1="47.095%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-d" x1="50%" x2="56.658%" y1="30.606%" y2="68%">
        <stop offset="0%" stopColor="#FFB60D" />
        <stop offset="100%" stopColor="#FF6110" />
      </linearGradient>
      <radialGradient id="icon-gift-e" r="47.592%" fx="50%" fy="50%">
        <stop offset="0%" stopColor="#FFF7E6" stopOpacity=".831" />
        <stop offset="43.861%" stopColor="#FFE0A8" stopOpacity=".251" />
        <stop offset="100%" stopColor="#FFE2B8" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-f" x1="23.855%" x2="50%" y1="27.485%" y2="65.991%">
        <stop offset="0%" stopColor="#FF5F3F" />
        <stop offset="100%" stopColor="#E62E2E" stopOpacity=".989" />
      </linearGradient>
      <radialGradient
        id="icon-gift-h"
        cx="32.604%"
        cy="35.13%"
        r="76.548%"
        fx="32.604%"
        fy="35.13%"
        gradientTransform="matrix(.13446 .968 -.58853 .28484 .489 -.064)"
      >
        <stop offset="0%" stopColor="#FF7E57" stopOpacity=".5" />
        <stop offset="100%" stopColor="#F88" stopOpacity="0" />
      </radialGradient>
      <path
        id="icon-gift-g"
        d="M0 0h56v19.744c0 3.567-.371 4.86-1.069 6.163a7.27 7.27 0 0 1-3.024 3.024C50.604 29.63 49.311 30 45.744 30H10.256c-3.567 0-4.86-.371-6.163-1.069a7.27 7.27 0 0 1-3.024-3.024C.37 24.604 0 23.311 0 19.744V0z"
      />
      <filter id="icon-gift-i" width="108.9%" height="116.7%" x="-4.5%" y="-8.3%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="1.5" />
        <feOffset dx="-2" dy="-2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.537392437 0 0 0 0 0.144291098 0 0 0 0 0.144291098 0 0 0 0.770104895 0"
        />
      </filter>
      <linearGradient id="icon-gift-j" x1="50%" x2="50.473%" y1="-3.873%" y2="100%">
        <stop offset="0%" stopColor="#FFC53F" />
        <stop offset="78.785%" stopColor="#FFBF2A" />
        <stop offset="89.102%" stopColor="#F39125" />
        <stop offset="100%" stopColor="#8D3B00" />
      </linearGradient>
      <linearGradient id="icon-gift-k" x1="50%" x2="54.152%" y1="47.697%" y2="53.473%">
        <stop offset="0%" stopColor="#FF6660" />
        <stop offset="100%" stopColor="#E62E2E" />
      </linearGradient>
      <radialGradient
        id="icon-gift-l"
        cx="-3.85%"
        cy="-146.76%"
        r="372.277%"
        fx="-3.85%"
        fy="-146.76%"
        gradientTransform="scale(-.22222 -1) rotate(-84.472 1.684 -.117)"
      >
        <stop offset="0%" stopColor="#FFC464" />
        <stop offset="100%" stopColor="#FFB86B" stopOpacity="0" />
      </radialGradient>
      <path id="icon-gift-m" d="M72 95h56l6.553 13.106a2 2 0 0 1-1.79 2.894H67.237a2 2 0 0 1-1.789-2.894L72 95z" />
      <filter id="icon-gift-n" width="100.7%" height="118.8%" x="-.4%" y="-9.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation=".5" />
        <feOffset dx="-1" dy="-1" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.447265625 0 0 0 0 0 0 0 0 0 0 0 0 0 0.244454764 0"
        />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="1" />
        <feOffset dx="1" dy="1" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 1 0 0 0 0 0.944975242 0 0 0 0 0.784146341 0 0 0 0.378660402 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <radialGradient
        id="icon-gift-o"
        cy="-50.166%"
        r="136.252%"
        fx="50%"
        fy="-50.166%"
        gradientTransform="matrix(0 1 -.37992 0 .31 -1.002)"
      >
        <stop offset="0%" stopColor="#FFD083" />
        <stop offset="100%" stopColor="#FFC88D" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="icon-gift-p" x1="50%" x2="50%" y1="4.731%" y2="100%">
        <stop offset="0%" stopColor="#FFE2B8" stopOpacity="0" />
        <stop offset="41.528%" stopColor="#FFE0A8" stopOpacity=".048" />
        <stop offset="100%" stopColor="#FFDC91" stopOpacity=".254" />
      </linearGradient>
      <linearGradient id="icon-gift-q" x1="50%" x2="50%" y1="4.731%" y2="100%">
        <stop offset="0%" stopColor="#FFE2B8" stopOpacity="0" />
        <stop offset="41.528%" stopColor="#FFE0A8" stopOpacity=".048" />
        <stop offset="100%" stopColor="#FFDC91" stopOpacity=".227" />
      </linearGradient>
      <linearGradient id="icon-gift-r" x1="50%" x2="56.658%" y1="1.946%" y2="94.599%">
        <stop offset="0%" stopColor="#FFB60D" />
        <stop offset="100%" stopColor="#FF6110" />
      </linearGradient>
      <linearGradient id="icon-gift-s" x1="45.198%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-t" x1="23.855%" x2="50%" y1="-12.805%" y2="94.607%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      <linearGradient id="icon-gift-u" x1="43.464%" x2="50%" y1="-28.452%" y2="105.72%">
        <stop offset="0%" stopColor="#FFAB64" />
        <stop offset="100%" stopColor="#FF2641" stopOpacity=".989" />
      </linearGradient>
      {/* end IconGift */}

      {/* IconInputError */}
      <clipPath id="icon-input-error-0">
        <rect width="12" height="12" fill="white" transform="translate(4 4)" />
      </clipPath>
      {/* end IconInputError */}

      {/* IconArrowCircled */}
      <clipPath id="icon-arrow-circled">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h30v30H0z" />
      </clipPath>
      {/* end IconArrowCircled */}

      {/* User loyalty progress bar gradient */}
      <linearGradient id="loyalty-progress-linear-gradient">
        <stop stopColor={colors.primaryHover} />
        <stop offset="1" stopColor={colors.primary} />
      </linearGradient>
      {/* User loyalty progress bar gradient */}

      {/* IconStatusApproved */}
      <clipPath id="icon-status-approved">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h30v30H0z" />
      </clipPath>
      {/* end IconStatusApproved */}

      {/* IconStatusFailed */}
      <clipPath id="icon-status-failed">
        <rect width="10.2857" height="10.2857" fill="white" transform="translate(3.85742 3.85712)" />
      </clipPath>
      {/* end IconStatusFailed */}

      {/* IconClock */}
      <clipPath id="icon-clock">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
      {/* end IconClock */}

      {/* IconStatusRequired */}
      <clipPath id="icon-status-required-clip0_4572_218">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="icon-status-required-clip1_4572_218">
        <rect width="12" height="12" fill="white" transform="matrix(1 0 0 -1 4 15.9999)" />
      </clipPath>
      {/* end IconStatusRequired */}

      {/* IconProviderGGames */}
      <linearGradient
        id="g-games-a"
        x1="12.8679"
        y1="-0.462736"
        x2="12.8679"
        y2="24.5423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF155B" />
        <stop offset="1" stopColor="#BF0E92" />
      </linearGradient>
      {/* IconProviderGGames */}

      {/* IconProviderBGAMING */}
      <clipPath id="icon-bgaming-a">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
      {/* IconProviderBGAMING */}

      {/* IconProviderCandleBetsBig */}
      <linearGradient
        id="candle-bets-big-b"
        x1="5.91111"
        y1="15.5215"
        x2="15.1194"
        y2="24.6966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#26DCBA" />
        <stop offset="1" stopColor="#1BB1BA" />
      </linearGradient>
      <linearGradient
        id="candle-bets-big-c"
        x1="6.47424"
        y1="6.34067"
        x2="6.47424"
        y2="17.8778"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#560057" />
        <stop offset="1" stopColor="#CB043F" />
      </linearGradient>
      <linearGradient
        id="candle-bets-big-d"
        x1="23.1819"
        y1="7.93823"
        x2="10.2288"
        y2="7.93823"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6823" />
        <stop offset="1" stopColor="#FFA452" />
      </linearGradient>
      <linearGradient
        id="candle-bets-big-e"
        x1="19.4039"
        y1="3.06323"
        x2="4.2855"
        y2="6.82919"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F61F1A" />
        <stop offset="1" stopColor="#FF510B" />
      </linearGradient>
      <linearGradient
        id="candle-bets-big-f"
        x1="23.1822"
        y1="16.6049"
        x2="8.06385"
        y2="12.8389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32D6AB" />
        <stop offset="1" stopColor="#B0FCE6" />
      </linearGradient>
      <clipPath id="candle-bets-big-a">
        <rect width="25.8377" height="26" fill="white" />
      </clipPath>
      {/* IconProviderCandleBetsBig */}

      {/* IconProviderCandleBets */}
      <linearGradient
        id="candle-bets-a"
        x1="4.28958"
        y1="14.5263"
        x2="15.0264"
        y2="25.2632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#26DCBA" />
        <stop offset="1" stopColor="#1BB1BA" />
      </linearGradient>
      <linearGradient
        id="candle-bets-b"
        x1="4.94843"
        y1="3.82146"
        x2="4.94843"
        y2="17.2736"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#560057" />
        <stop offset="1" stopColor="#CB043F" />
      </linearGradient>
      <linearGradient
        id="candle-bets-c"
        x1="24.4998"
        y1="5.68419"
        x2="9.34187"
        y2="5.6842"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6823" />
        <stop offset="1" stopColor="#FFA452" />
      </linearGradient>
      <linearGradient
        id="candle-bets-d"
        x1="20.0787"
        y1="-1.56985e-05"
        x2="2.3945"
        y2="4.42104"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F61F1A" />
        <stop offset="1" stopColor="#FF510B" />
      </linearGradient>
      <linearGradient
        id="candle-bets-e"
        x1="24.5"
        y1="15.7895"
        x2="6.81576"
        y2="11.3684"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32D6AB" />
        <stop offset="1" stopColor="#B0FCE6" />
      </linearGradient>
      <clipPath id="candle-bets-f">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
      {/* IconProviderCandleBets */}

      {/* IconProvider3oaks */}
      <linearGradient
        id="icom-provider-3oaks-a"
        x1="24.1522"
        y1="1.29393"
        x2="17.459"
        y2="10.4315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      <linearGradient
        id="icom-provider-3oaks-b"
        x1="15.7703"
        y1="1.29395"
        x2="9.07713"
        y2="10.4315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      <linearGradient
        id="icom-provider-3oaks-c"
        x1="7.38823"
        y1="1.29393"
        x2="0.695026"
        y2="10.4315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      {/* IconProvider3oaks */}

      {/* IconProvider3oaksGamingBig */}
      <linearGradient
        id="icon-provider-3-oks-gaming-big-gradient-1"
        x1="50.8274"
        y1="0.823148"
        x2="37.2583"
        y2="20.1831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      <linearGradient
        id="icon-provider-3-oks-gaming-big-gradient-2"
        x1="32.8149"
        y1="0.823195"
        x2="19.2457"
        y2="20.1831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      <linearGradient
        id="icon-provider-3-oks-gaming-big-gradient-3"
        x1="14.8026"
        y1="0.823147"
        x2="1.23344"
        y2="20.1831"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8B900" />
        <stop offset="1" stopColor="#E67508" />
      </linearGradient>
      <clipPath id="icon-provider-3-oks-gaming-big-clip">
        <rect width="124" height="21" fill="white" />
      </clipPath>
      {/* end IconProvider3oaksGamingBig */}

      {/* IconProviderAviatrix */}
      <linearGradient
        id="icon-provider-aviatrix-a"
        x1="115.745"
        y1="6.97656"
        x2="115.745"
        y2="221.892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.277959" stopColor="#EBE0F1" />
        <stop offset="0.774474" stopColor="white" />
        <stop offset="1" stopColor="#B59CC9" />
      </linearGradient>
      <linearGradient
        id="icon-provider-aviatrix-b"
        x1="115.745"
        y1="6.97656"
        x2="115.745"
        y2="221.892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.277959" stopColor="#EBE0F1" />
        <stop offset="0.774474" stopColor="white" />
        <stop offset="1" stopColor="#B59CC9" />
      </linearGradient>
      <linearGradient
        id="icon-provider-aviatrix-c"
        x1="115.745"
        y1="6.97656"
        x2="115.745"
        y2="221.892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.277959" stopColor="#EBE0F1" />
        <stop offset="0.774474" stopColor="white" />
        <stop offset="1" stopColor="#B59CC9" />
      </linearGradient>
      <linearGradient
        id="icon-provider-aviatrix-d"
        x1="115.745"
        y1="6.97656"
        x2="115.745"
        y2="221.892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.277959" stopColor="#EBE0F1" />
        <stop offset="0.774474" stopColor="white" />
        <stop offset="1" stopColor="#B59CC9" />
      </linearGradient>
      <clipPath id="icon-provider-aviatrix-e">
        <rect width="228" height="228" fill="white" />
      </clipPath>
      {/* end IconProviderAviatrix */}

      {/* IconProviderApollo */}
      <linearGradient
        id="icon-provider-apollo"
        x1="22.5142"
        y1="16.8765"
        x2="38.8367"
        y2="45.1964"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFF66" />
        <stop offset="0.46" stopColor="#FFD800" />
        <stop offset="1" stopColor="#FFA500" />
      </linearGradient>
      {/* end IconProviderApollo */}

      {/* IconProviderApolloBig */}
      <clipPath id="icon-provider-apollo-big">
        <rect width="141" height="38" fill="white" transform="translate(8 17)" />
      </clipPath>
      {/* end IconProviderApolloBig */}

      {/* IconProviderEgt */}
      <linearGradient id="icon-provider-egt-a" x1="77.939%" x2="35.988%" y1="26.718%" y2="74.299%">
        <stop offset="0%" stopColor="#00A48B" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <path
        id="icon-provider-egt-b"
        d="M4.032 8.256a3.974 3.974 0 0 0 3.984-3.984A3.974 3.974 0 0 0 4.032.288 3.974 3.974 0 0 0 .048 4.272C.096 6.48 1.872 8.256 4.032 8.256z"
      />
      <linearGradient id="icon-provider-egt-c" x1="-.09%" x2="99.998%" y1="50.044%" y2="50.044%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <linearGradient id="icon-provider-egt-e" x1="74.723%" x2="25.686%" y1="93.213%" y2="7.16%">
        <stop offset="0%" stopColor="#91C73E" />
        <stop offset="100%" stopColor="#0092C0" />
      </linearGradient>
      {/* end IconProviderEgt */}

      {/* IconProviderEgtBig */}
      <linearGradient id="icon-provider-egt-big-a" x1="77.939%" x2="35.988%" y1="26.718%" y2="74.299%">
        <stop offset="0%" stopColor="#00A48B" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <path id="icon-provider-egt-big-b" d="M12.857 0v3.571h-8.84v3.661h7.947v3.393H4.018v3.66h9.107v3.483H0V0z" />
      <linearGradient id="icon-provider-egt-big-c" x1=".045%" x2="100.086%" y1="50.083%" y2="50.083%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <mask id="icon-provider-egt-big-d" fill="#fff">
        <use xlinkHref="#icon-provider-egt-big-b" />
      </mask>
      <linearGradient id="icon-provider-egt-big-e" x1="8.451%" x2="91.589%" y1="16.712%" y2="69.544%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <path
        id="icon-provider-egt-big-f"
        d="M13.375 9.107h4.018v6.34c-1.786 1.964-4.197 2.946-7.322 2.946-2.589 0-4.821-.893-6.607-2.59C1.68 14.108.786 11.876.786 9.287c0-2.679.893-4.822 2.678-6.607C5.25.893 7.482 0 9.982 0c2.59 0 4.732.804 6.607 2.5l-2.053 2.946c-.804-.714-1.518-1.16-2.232-1.428-.625-.268-1.429-.357-2.143-.357-1.518 0-2.768.535-3.84 1.518-1.071.982-1.517 2.41-1.517 4.017 0 1.608.535 3.036 1.517 4.018.983.982 2.143 1.518 3.572 1.518 1.34 0 2.5-.268 3.393-.803V9.107h.089z"
      />
      <linearGradient id="icon-provider-egt-big-g" x1="11.131%" x2="90.519%" y1="74.098%" y2="16.674%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <mask id="icon-provider-egt-big-h" fill="#fff">
        <use xlinkHref="#icon-provider-egt-big-f" />
      </mask>
      <path id="icon-provider-egt-big-i" d="M9.778 3.571v14.375H5.85V3.571h-5V.18h14.018V3.57z" />
      <linearGradient id="icon-provider-egt-big-j" x1="88.52%" x2="31.766%" y1="89.842%" y2="-5.99%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <mask id="icon-provider-egt-big-k" fill="#fff">
        <use xlinkHref="#icon-provider-egt-big-i" />
      </mask>
      <linearGradient id="icon-provider-egt-big-l" x1="28.661%" x2="88.891%" y1="85.813%" y2="20.075%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <path
        id="icon-provider-egt-big-m"
        d="M7.5 15.357a7.392 7.392 0 0 0 7.41-7.41A7.392 7.392 0 0 0 7.5.535a7.392 7.392 0 0 0-7.41 7.41c.089 4.108 3.392 7.411 7.41 7.411z"
      />
      <linearGradient id="icon-provider-egt-big-n" x1="-.09%" x2="99.998%" y1="50.044%" y2="50.044%">
        <stop offset="0%" stopColor="#0092C0" />
        <stop offset="99.95%" stopColor="#A5CD39" />
      </linearGradient>
      <mask id="icon-provider-egt-big-o" fill="#fff">
        <use xlinkHref="#icon-provider-egt-big-m" />
      </mask>
      <linearGradient id="icon-provider-egt-big-p" x1="74.723%" x2="25.686%" y1="93.213%" y2="7.16%">
        <stop offset="0%" stopColor="#91C73E" />
        <stop offset="100%" stopColor="#0092C0" />
      </linearGradient>
      {/* end IconProviderEgtBig */}

      {/* IconProviderFazi */}
      <clipPath id="icon-fazi">
        <rect width="57.9303" height="22" fill="white" transform="translate(1 19)" />
      </clipPath>
      {/* end IconProviderFazi */}

      {/* IconLogoMobile */}
      <linearGradient
        id="icon-logo-mobile-gradient-1"
        x1="21.7345"
        y1="23.2"
        x2="21.7345"
        y2="34.8071"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF66" />
        <stop offset="1" stopColor="#00B147" />
      </linearGradient>
      <clipPath id="icon-logo-mobile-gradient-2">
        <rect width="58" height="58" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-gradient-3">
        <rect width="52.2" height="13.05" fill="white" transform="translate(2.89999 23.2)" />
      </clipPath>
      {/* end IconLogoMobile */}

      {/* IconLogo */}
      <linearGradient
        id="icon-logo-paint0_linear_226_11148"
        x1="79.3789"
        y1="0.00012207"
        x2="79.3789"
        y2="46.4313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF66" />
        <stop offset="1" stopColor="#00B147" />
      </linearGradient>
      <clipPath id="icon-logo-clip0_226_11148">
        <rect width="220" height="52.2034" fill="white" />
      </clipPath>
      {/* end IconLogo */}

      {/* IconProviderGamzix */}
      <linearGradient
        id="icon-provider-gamzix-paint0_linear_2_2"
        x1="3.32583"
        y1="12.9729"
        x2="14.7922"
        y2="10.3502"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0073587" stopColor="#352B19" />
        <stop offset="1" stopColor="#DEA329" />
      </linearGradient>
      <linearGradient
        id="icon-provider-gamzix-paint1_linear_2_2"
        x1="1.92313"
        y1="3.03543"
        x2="3.83946"
        y2="12.6354"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0073587" stopColor="#352B19" />
        <stop offset="1" stopColor="#DEA329" />
      </linearGradient>
      <clipPath id="icon-provider-gamzix-clip0_2_2">
        <rect width="64" height="14" fill="white" />
      </clipPath>
      {/* end IconProviderGamzix */}

      {/* IconLineApp */}
      <clipPath id="icon-line-app">
        <rect width="20" height="20" fill="white" transform="translate(0.1875)" />
      </clipPath>
      {/* end IconLineApp */}

      {/* IconLogoLarge start */}
      <linearGradient
        id="icon-logo-large-linear-1"
        x1="153.947"
        y1="-9.5851e-08"
        x2="155.234"
        y2="39.9993"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF493C" />
        <stop offset="0.463988" stopColor="#C14C44" />
        <stop offset="0.470953" stopColor="#B32B1F" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <linearGradient
        id="icon-logo-large-linear-2"
        x1="44.2679"
        y1="-9.09022e-08"
        x2="45.9449"
        y2="39.9988"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.561973" stopColor="#EFEFF3" />
        <stop offset="0.568185" stopColor="#EAEAEF" />
        <stop offset="1" stopColor="#DBDCE4" />
      </linearGradient>
      <linearGradient
        id="icon-logo-large-linear-3"
        x1="44.6375"
        y1="5.02002"
        x2="45.6421"
        y2="30.771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF493C" />
        <stop offset="0.669411" stopColor="#C14C44" />
        <stop offset="0.687132" stopColor="#B32B1F" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <clipPath id="icon-logo-large-clippath">
        <rect width="222" height="40" fill="white" />
      </clipPath>
      {/* IconLogoLarge end */}

      {/* IconLogoMobile start */}
      <linearGradient
        id="icon-logo-mobile-linear"
        x1="19.9877"
        y1="12.5"
        x2="19.9877"
        y2="20.469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CF493C" />
        <stop offset="1" stopColor="#9B2C27" />
      </linearGradient>
      <clipPath id="icon-logo-mobile-clip-0">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip-1">
        <rect width="40" height="40" fill="white" />
      </clipPath>
      <clipPath id="icon-logo-mobile-clip-2">
        <rect width="36" height="18" fill="white" transform="translate(2 11)" />
      </clipPath>
      {/* IconLogoMobile end */}

      {/* IconPep start */}
      <clipPath id="icon-pep-clip">
        <rect width="30" height="30" fill="white" transform="translate(0.169189 0.5)" />
      </clipPath>
      {/* IconPep end */}

      {/* IconPaybol start */}
      <clipPath id="icon-paybol-clip">
        <rect width="98" height="30" fill="white" transform="translate(0.169189 0.5)" />
      </clipPath>
      {/* IconPaybol end */}

      {/* IconPlayCircle start */}
      <linearGradient
        id="icon-play-circle-0"
        x1="31.9999"
        y1="4.36365"
        x2="31.9999"
        y2="59.6364"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB802" />
        <stop offset="1" stopColor="#FF8B20" />
      </linearGradient>
      <linearGradient
        id="icon-play-circle-1"
        x1="31.9999"
        y1="5.81818"
        x2="31.9999"
        y2="58.1818"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD765" stopOpacity="0.08" />
        <stop offset="1" stopColor="#FFC035" />
      </linearGradient>
      {/* IconPlayCircle end */}

      {/* IconSuccess */}
      <linearGradient
        id="icon-success-paint0_linear_4406_25233"
        x1="22"
        y1="4.68115"
        x2="22"
        y2="39.3195"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3DFD3F" />
        <stop offset="1" stopColor="#44EA10" />
      </linearGradient>

      <linearGradient id="icon_success" x1="21" y1="6" x2="21" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconSuccess end */}

      {/* IconSuccessBig */}
      <linearGradient
        id="icon-success-big-paint0_linear_992_127"
        x1="47.9999"
        y1="10.2126"
        x2="47.9999"
        y2="85.7871"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3DFD3F" />
        <stop offset="1" stopColor="#44EA10" />
      </linearGradient>
      {/* IconSuccessBig end */}

      {/* IconSlotMachine */}
      <linearGradient
        id="slot-machine"
        x1="19"
        y1="8.50732"
        x2="19"
        y2="28.4926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00b147" />
        <stop offset="1" stopColor="#008e39" />
      </linearGradient>
      {/* IconSlotMachine end */}

      {/* IconCasinoLive */}
      <linearGradient
        id="casino-live"
        x1="11.5001"
        y1="0.882812"
        x2="11.5001"
        y2="22.1172"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconCasinoLive end */}

      {/* IconSlot */}
      <linearGradient
        id="slot-1"
        x1="15.6431"
        y1="12.8615"
        x2="15.6431"
        y2="20.5001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="slot-2"
        x1="5.35694"
        y1="12.8615"
        x2="5.35694"
        y2="20.5001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="slot-3"
        x1="7.41214"
        y1="6.14099"
        x2="7.41214"
        y2="11.8556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="slot-4"
        x1="12.9907"
        y1="6.66028"
        x2="12.9907"
        y2="11.7959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="slot-5"
        x1="12.0369"
        y1="0.5"
        x2="12.0369"
        y2="5.56715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="slot-6">
        <rect width="20" height="20" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>

      <clipPath id="icons-header-clip-path-1">
        <rect width="20" height="20" fill="white" transform="translate(8.5 8)" />
      </clipPath>
      {/* IconSlot */}

      {/* IconPromos */}
      <linearGradient
        id="promos"
        x1="10"
        y1="0.882812"
        x2="10"
        y2="22.1172"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconPromos end */}

      {/* IconTournaments */}
      <linearGradient
        id="tournaments"
        x1="18.8681"
        y1="7"
        x2="18.8681"
        y2="28.2344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconTournaments end */}

      {/* IconSports */}
      <linearGradient
        id="icon-sports-paint-linear"
        x1="25.2484"
        y1="11.1108"
        x2="10.7517"
        y2="24.8892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="icon-sports-clip">
        <rect width="19.9997" height="20" fill="white" transform="translate(8 8)" />
      </clipPath>
      {/* IconSports end */}

      {/* IconInPlay */}
      <linearGradient id="inPlay-1" x1="10" y1="17.5" x2="10" y2="19.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="inPlay-2" x1="10" y1="2.5" x2="10" y2="14.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>

      <linearGradient id="icon-in-play-a" x1="18" y1="25" x2="18" y2="27" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="icon-in-play-b" x1="18" y1="10" x2="18" y2="22" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconInPlay end */}

      {/* IconIconVerificationIdentity */}
      <linearGradient
        id="icon-verification-identity-paint0_linear_4572_226"
        x1="17.4984"
        y1="7"
        x2="17.4984"
        y2="29"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* IconVerificationIdentity end */}

      {/* IconVerificationAddress end */}
      <linearGradient
        id="icon-verification-address-paint0_linear_4572_264"
        x1="18"
        y1="7"
        x2="18"
        y2="29"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* IconVerificationAddress end */}

      {/* IconVerificationPayment */}
      <linearGradient
        id="icon-verification-payment-paint0_linear_4572_280"
        x1="18"
        y1="8.125"
        x2="18"
        y2="27.375"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* IconVerificationPayment end */}

      {/* IconIconVerificationIdentityOther */}
      <linearGradient
        id="icon-verification-identity-other-paint0_linear_4572_247"
        x1="17.4984"
        y1="7"
        x2="17.4984"
        y2="29"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* IconIconVerificationIdentityOther end */}

      {/* IconIconVerificationSelfie */}
      <linearGradient
        id="icon-verification-selfie-paint0_linear_4572_274"
        x1="18"
        y1="8.1001"
        x2="18"
        y2="27.9001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* IconIconVerificationSelfie end */}

      {/* check-gradient start */}
      <linearGradient
        id="check-gradient"
        x1="11.1785"
        y1="3.73706"
        x2="11.1785"
        y2="16.3244"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* check-gradient end */}

      {/* all-games start */}
      <linearGradient id="all_1" x1="7.65" y1="0" x2="7.65" y2="15.3" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="all_2" x1="7.65" y1="18.7" x2="7.65" y2="34" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="all_3" x1="26.35" y1="0" x2="26.35" y2="15.3" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="all_4" x1="26.35" y1="18.7" x2="26.35" y2="34" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* all-games end */}

      {/* live start */}
      <linearGradient id="live_1" x1="19.393" y1="0.821289" x2="19.393" y2="45" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="live_2" x1="19.3929" y1="11.7221" x2="19.3929" y2="37.9215" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* live end */}

      {/* slots start */}
      <linearGradient id="slots_1" x1="33.3147" y1="27.1951" x2="33.3147" y2="44" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <linearGradient id="slots_2" x1="10.6853" y1="27.1949" x2="10.6853" y2="43.9999" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <linearGradient id="slots_3" x1="15.102" y1="10.0001" x2="15.102" y2="28.0001" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="slots_4" x1="26.3832" y1="10.5002" x2="26.3832" y2="28.0002" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="slots_5" x1="24.5" y1="0" x2="24.5" y2="12" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="slots_6">
        <rect width="44" height="44" fill="white" />
      </clipPath>
      {/* slots end */}

      {/* roulette start */}
      <linearGradient id="roulette_2" x1="21.393" y1="0.785706" x2="21.393" y2="43.2143" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="roulette_3"
        x1="21.3929"
        y1="10.7089"
        x2="21.3929"
        y2="33.2913"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <clipPath id="roulette_1">
        <rect width="42.4286" height="42.4286" fill="white" transform="translate(0.178711 0.785706)" />
      </clipPath>
      {/* roulette end */}

      {/* blackjack start */}
      <linearGradient
        id="blackjack_1"
        x1="25.8379"
        y1="3.55981"
        x2="25.8379"
        y2="42.5598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="blackjack_2"
        x1="14.238"
        y1="1.77392"
        x2="17.7529"
        y2="42.7425"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      {/* blackjack end */}

      {/* search start */}
      <linearGradient id="search_1" x1="33.9456" y1="26.249" x2="33.9456" y2="43.2135" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="search_2" x1="16.159" y1="0.785767" x2="16.159" y2="33.1038" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <linearGradient id="search_3" x1="16.1069" y1="9.42859" x2="16.1069" y2="29.8572" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#FFECCB" />
      </linearGradient>
      {/* search end */}

      {/* favorite start */}
      <linearGradient
        id="favorite_1"
        x1="18.8947"
        y1="0.278143"
        x2="14.7801"
        y2="23.2992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F2D254" />
        <stop offset="0.04" stopColor="#F3CA52" />
        <stop offset="0.25" stopColor="#F7A249" />
        <stop offset="0.45" stopColor="#FB8342" />
        <stop offset="0.65" stopColor="#FD6C3D" />
        <stop offset="0.83" stopColor="#FF5F3A" />
        <stop offset="1" stopColor="#FF5A39" />
      </linearGradient>
      <linearGradient id="favorite_2" x1="26.7355" y1="13.873" x2="26.7355" y2="40.7896" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <linearGradient id="favorite_3" x1="5.753" y1="11.8993" x2="5.753" y2="42.7521" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* favorite end */}

      {/* notfound start */}
      <linearGradient id="notfound_1" x1="29.9824" y1="0" x2="29.9824" y2="59.9647" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFC702" />
        <stop offset="1" stopColor="#FF8B20" />
      </linearGradient>
      <linearGradient id="notfound_2" x1="0" y1="29.9597" x2="59.9768" y2="29.9597" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFA510" />
        <stop offset="0.98" stopColor="#FFCE7A" />
        <stop offset="1" stopColor="#FABEBA" />
      </linearGradient>
      {/* notfound end */}

      {/* notfound with mark start */}
      <linearGradient
        id="not_found_with_mark_0"
        x1="29.9824"
        y1="0"
        x2="29.9824"
        y2="59.9647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC702" />
        <stop offset="1" stopColor="#FF8B20" />
      </linearGradient>
      <linearGradient
        id="not_found_with_mark_1"
        x1="0"
        y1="29.9597"
        x2="59.9768"
        y2="29.9597"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA510" />
        <stop offset="0.98" stopColor="#FFCE7A" />
        <stop offset="1" stopColor="#FABEBA" />
      </linearGradient>
      <linearGradient
        id="not_found_with_mark_2"
        x1="53.9887"
        y1="86.8604"
        x2="53.9887"
        y2="11.9533"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#ADDCFF" />
        <stop offset="0.5028" stopColor="#EAF6FF" />
        <stop offset="1" stopColor="#EAF6FF" />
      </linearGradient>
      {/* notfound with mark end */}

      {/* IconGames */}
      <filter
        id="icon-games-filter"
        x="-4.38"
        y="-3.30308"
        width="148.76"
        height="148.76"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.07692" />
        <feGaussianBlur stdDeviation="20.69" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.317647 0 0 0 0 0.760784 0 0 0 0 0.905882 0 0 0 0.39 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_88_1329" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_88_1329" result="shape" />
      </filter>
      <linearGradient
        id="icon-games-1"
        x1="70.0136"
        y1="54.1641"
        x2="70.0136"
        y2="90.6703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#23C7FF" />
        <stop offset="1" stopColor="#B3ECFF" />
      </linearGradient>
      <linearGradient
        id="icon-games-2"
        x1="84.9366"
        y1="72.875"
        x2="84.9366"
        y2="81.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#23C7FF" />
        <stop offset="1" stopColor="#B3ECFF" />
      </linearGradient>
      <linearGradient id="icon-games-3" x1="69.5" y1="77" x2="69.5" y2="93.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#23C7FF" />
        <stop offset="1" stopColor="#B3ECFF" />
      </linearGradient>
      {/* IconGames end */}

      {/* IconPayment */}
      <filter
        id="icon-payment-filter"
        x="-3.38"
        y="-6.30308"
        width="148.76"
        height="148.76"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.07692" />
        <feGaussianBlur stdDeviation="20.69" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.908333 0 0 0 0 0.784793 0 0 0 0 0.295208 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_88_5262" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_88_5262" result="shape" />
      </filter>
      <linearGradient id="icon-payment-1" x1="64.6085" y1="50.8694" x2="64.6085" y2="37" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFEDAD" />
        <stop offset="1" stopColor="#FFFFE5" />
      </linearGradient>
      <linearGradient id="icon-payment-2" x1="69.2669" y1="89" x2="69.2669" y2="47.403" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFAE0A" />
        <stop offset="1" stopColor="#FFF195" />
      </linearGradient>
      <linearGradient
        id="icon-payment-3"
        x1="91.5148"
        y1="74.8658"
        x2="91.5148"
        y2="61.0001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE59A" />
        <stop offset="1" stopColor="#FFFFD5" />
      </linearGradient>
      <linearGradient
        id="icon-payment-4"
        x1="93.6473"
        y1="69.9348"
        x2="93.6473"
        y2="66.4684"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAF09" />
        <stop offset="1" stopColor="#FFDE00" />
      </linearGradient>
      {/* IconPayment end */}

      {/* IconWithdrawal */}
      <filter
        id="icon-withdrawal-filter"
        x="-5.38"
        y="-1.30308"
        width="148.76"
        height="148.76"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="5.07692" />
        <feGaussianBlur stdDeviation="20.69" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.521569 0 0 0 0 0.945098 0 0 0 0 0.74902 0 0 0 0.54 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_88_5227" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_88_5227" result="shape" />
      </filter>
      <linearGradient
        id="icon-withdrawal-1"
        x1="66.4788"
        y1="53.5614"
        x2="82.1169"
        y2="30.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7DFFC2" />
        <stop offset="1" stopColor="#D6FFF0" />
      </linearGradient>
      <linearGradient id="icon-withdrawal-2" x1="69" y1="44.5078" x2="69" y2="99" gradientUnits="userSpaceOnUse">
        <stop stopColor="#C4FFEB" />
        <stop offset="1" stopColor="#1BD976" />
      </linearGradient>
      <linearGradient
        id="icon-withdrawal-3"
        x1="71.3889"
        y1="82.6298"
        x2="96.8868"
        y2="69.5931"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C5FFE3" />
        <stop offset="1" stopColor="#D6FFF0" />
      </linearGradient>
      {/* IconWithdrawal end */}

      {/* Icon whatsapp start */}
      <linearGradient
        id="whatsapp-icon-gradient-1"
        x1="16.4741"
        y1="0.017334"
        x2="16.4741"
        y2="32.9827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="whatsapp-icon-gradient-2"
        x1="17.0011"
        y1="6.79868"
        x2="17.0011"
        y2="25.132"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* Icon whatsapp end */}

      {/* IconSearch */}
      <linearGradient
        id="icon-search-paint0_linear_1058_5522"
        x1="13.7053"
        y1="4.14807"
        x2="13.7053"
        y2="24.1014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconSearch end */}

      {/* IconDeposit */}
      <linearGradient
        id="icon-deposit-paint0_linear_1673_32223"
        x1="12"
        y1="0.800049"
        x2="12"
        y2="21.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconDeposit end */}

      {/* IconLogoSmall */}
      <linearGradient
        id="icon-logo-small-paint0_linear_1673_32195"
        x1="50.8747"
        y1="0"
        x2="50.8747"
        y2="28.4617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FF66" />
        <stop offset="1" stopColor="#00B147" />
      </linearGradient>
      <clipPath id="icon-logo-small-clip0_1673_32195">
        <rect width="141" height="32" fill="white" />
      </clipPath>
      {/* IconLogoSmall end */}

      {/* IconMenu */}
      <linearGradient
        id="icon-menu-paint0_linear_1673_32217"
        x1="14.6"
        y1="6.19995"
        x2="14.6"
        y2="22.9999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconMenu end */}

      {/* IconFacebook */}
      <linearGradient id="icon-fb" x1="16.4741" y1="0.017334" x2="16.4741" y2="32.9827" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="icon-fb-2" x1="16.87" y1="8.58838" x2="16.87" y2="24.4117" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconFacebook end */}

      {/* IconYoutube */}
      <linearGradient
        id="icon-youtube-1"
        x1="16.9857"
        y1="0.017334"
        x2="16.9857"
        y2="32.9827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient
        id="icon-youtube-2"
        x1="16.9857"
        y1="10.8022"
        x2="16.9857"
        y2="22.1977"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconYoutube end */}

      {/* IconGreenDot */}
      <linearGradient id="icon-green-dot" x1="7.5" y1="4" x2="7.5" y2="11" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconGreenDot end */}

      {/* IconTournamentsActive */}
      <linearGradient id="icon-tournaments-active-1" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <linearGradient id="icon-tournaments-active-2" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* IconTournamentsActive end */}

      {/* IconSupport */}
      <linearGradient id="support_icon" x1="10" y1="0.499878" x2="10" y2="20.9998" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* end IconSupport */}
      {/* IconVIP */}
      <linearGradient
        id="vip-icon-linear-paint"
        x1="18.5"
        y1="10.512"
        x2="18.5"
        y2="26.8333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="vip-icon-clip-path">
        <rect width="20" height="20" fill="white" transform="translate(8.5 8.5)" />
      </clipPath>
      {/* IconVIP end */}
      {/* IconFavorite */}
      <g clipPath="url(#favorite-icon-path)">
        <path
          d="M41.7234 15.4439L28.1197 14.1822L22.716 1.6343C22.3377 0.755688 21.0919 0.755688 20.7136 1.6343L15.3099 14.1823L1.70627 15.4439C0.753745 15.5323 0.368782 16.717 1.08744 17.3483L11.3514 26.3651L8.34768 39.6929C8.13736 40.6261 9.14517 41.3583 9.96767 40.8699L21.7148 33.8946L33.462 40.8699C34.2845 41.3583 35.2924 40.6261 35.0821 39.6929L32.0782 26.3651L42.3422 17.3483C43.0609 16.717 42.6759 15.5323 41.7234 15.4439Z"
          fill="url(#favorite_2)"
        />
        <path
          d="M22.716 1.6343C22.3377 0.755688 21.0919 0.755688 20.7136 1.6343L15.3099 14.1823L1.70627 15.4439C0.753745 15.5323 0.368782 16.717 1.08744 17.3483L11.3514 26.3651L8.34768 39.6929C8.13736 40.6261 9.14517 41.3583 9.96767 40.8699L12.5896 39.313C12.9525 24.3754 19.893 13.8562 25.3879 7.83866L22.716 1.6343Z"
          fill="url(#favorite_1)"
        />
      </g>
      <linearGradient
        id="favorite-icon-path-gradient-1"
        x1="21.7144"
        y1="9.5"
        x2="21.7148"
        y2="41.0258"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAD10" />
        <stop offset="1" stopColor="#FFE5B9" />
      </linearGradient>
      <linearGradient
        id="favorite-icon-path-gradient-2"
        x1="13.0516"
        y1="0.975342"
        x2="13.0516"
        y2="41.0258"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <clipPath id="favorite-icon-path">
        <rect width="41.999" height="41.999" fill="white" transform="translate(0.715332 0.000976562)" />
      </clipPath>
      {/* IconFavorite end */}
      {/* ChatIcon start */}
      <filter
        id="filter0_d_2092_26997"
        x="0.181219"
        y="0.0335667"
        width="121.638"
        height="121.638"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.85235" />
        <feGaussianBlur stdDeviation="15.4094" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.12769 0 0 0 0 0.139617 0 0 0 0 0.167448 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2092_26997" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2092_26997" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_2092_26997" x1="61" y1="27" x2="61" y2="87" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      <defs>
        <linearGradient id="icon-live-chat-1" x1="30" y1="0" x2="30" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00B147" />
          <stop offset="1" stopColor="#008E39" />
        </linearGradient>
      </defs>
      {/* ChatIcon end */}

      {/*   IconBancoAzteca start */}
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#banco_azteca_2" transform="scale(0.0047619)" />
        </pattern>
        <image
          id="banco_azteca_2"
          width="210"
          height="210"
          xlinkHref="data:image/jpeg;base64,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"
        />
      </defs>
      {/*   IconBancoAzteca end */}

      {/*   IconSantanderSuperNet start */}
      <defs>
        <pattern id="standart-super-net" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_145_16" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_145_16"
          width="512"
          height="512"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
      {/*   IconSantanderSuperNet end */}

      {/*   IconAmigoGaming start */}
      <linearGradient id="paint0_linear_208_271" x1="12.5" y1="2" x2="12.5" y2="21.32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFC629" />
        <stop offset="1" stopColor="#F8312A" />
      </linearGradient>
      {/*   IconAmigoGaming end */}

      {/*   IconAmigoGamingBig start */}
      <linearGradient id="paint0_linear_208_268" x1="70.5" y1="4" x2="70.5" y2="75" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFC629" />
        <stop offset="1" stopColor="#F8312A" />
      </linearGradient>
      {/*   IconAmigoGamingBig end */}

      {/* IconProviderOnlyPlay */}
      <linearGradient
        id="icon-provider-only-play-paint0_linear_1404_204"
        x1="30.0958"
        y1="-0.374223"
        x2="30.0958"
        y2="60.0262"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <linearGradient
        id="icon-provider-only-play-paint1_linear_1404_204"
        x1="30.0958"
        y1="19.7593"
        x2="30.0958"
        y2="39.8926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F79F2D" />
        <stop offset="1" stopColor="#FF4D4D" />
      </linearGradient>
      <clipPath id="icon-provider-only-play-clip0_1404_204">
        <rect width="60" height="60" fill="white" />
      </clipPath>
      {/* end IconProviderOnlyPlay */}

      {/* IconDesktopSearch */}
      <linearGradient
        id="icon_desktop_search"
        x1="13.7053"
        y1="4.14807"
        x2="13.7053"
        y2="24.1014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B147" />
        <stop offset="1" stopColor="#008E39" />
      </linearGradient>
      {/* end IconDesktopSearch */}

      {/* IconAvatarux */}
      <clipPath id="avatarux-big-1">
        <rect width="139" height="46" fill="white" />
      </clipPath>
      {/* end IconAvatarux */}

      {/* IconGiftWithCircle */}
      <linearGradient id="icon-gift-with-circle-paint0_linear_7359_33977" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF4910" />
        <stop offset="1" stopColor="#D83502" />
      </linearGradient>
      <clipPath id="icon-gift-with-circle-clip0_7359_33977">
        <rect width="36" height="36" fill="white" />
      </clipPath>
      {/* end IconGiftWithCircle */}
    </defs>
  </svg>
);
